import React from "react";
import { StickyNote } from "lucide-react";
import { WebViewPopover } from "../../SubHeader/WebViewPopover";
import { EDSButton } from "../../../../eds/EDSButton";

type RefundClaimNoteType = {
  notes: string;
};

export const RefundClaimNote = ({ notes }: RefundClaimNoteType) => {
  if (!notes) {
    return null;
  }

  return (
    <div className="PaymentNote w-9">
      <WebViewPopover
        side="bottom"
        content={
          <div className="PaymentNote-Container p-3 bg-background border border-border rounded-lg">
            <div className="PaymentNote-Header font-semibold text-sm mb-1">
              Notes
            </div>
            <div className="PaymentNote-Content text-sm text-muted-foreground">
              {notes}
            </div>
          </div>
        }
      >
        <EDSButton size="icon" variant="outline" aria-label="View notes">
          <StickyNote className="w-4 h-4" />
        </EDSButton>
      </WebViewPopover>
    </div>
  );
};
